export const initialEmployeesState = {
  employees: [],
  loading: false,
};

export interface IEmployeesState {
  employees: any[],
  loading: boolean,
}


